<div
  *ngIf="tenantCitationStyles.length"
  dropdown
  class="dropdown"
  keyboard-nav="true"
>
  <button
    dropdownToggle
    id="citation-dd"
    class="btn btn-default columns dropdown-toggle shrink"
    data-bs-toggle="dropdown"
    type="button"
    [tooltip]="citationStyleToolTipTemplate"
    [isDisabled]="!isFilterLabelTruncated"
    container="body"
    placement="bottom"
    rlElementOverflowListener
    (elementTruncated)="onFilterLabelTruncate($event)"
    [elementSelector]="'.filter-menu__label--truncated'"
  >
    <span class="filter-menu__label--truncated">
      <ng-container [ngSwitch]="defaultCitationStyle?.id">
        <ng-container
          *ngSwitchCase="currentCitationStyle.id"
          i18n="@@citationSwitcherMenu-label-citationStyle-default"
        >
          Citation Style: {{ defaultCitationStyle.description }} (default)
        </ng-container>
        <ng-container
          *ngSwitchDefault
          i18n="@@citationSwitcherMenu-label-citationStyle"
        >
          Citation Style: {{ currentCitationStyle.description }}
        </ng-container>
      </ng-container>
    </span>
  </button>

  <ng-template #citationStyleToolTipTemplate>
    <ng-container [ngSwitch]="defaultCitationStyle?.id">
      <ng-container
        *ngSwitchCase="currentCitationStyle.id"
        i18n="@@citationSwitcherMenu-tooltip-citationStyle-default"
      >
        {{ defaultCitationStyle.description }} (default)
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ currentCitationStyle.description }}
      </ng-container>
    </ng-container>
  </ng-template>

  <ul *dropdownMenu class="dropdown-menu">
    <li>
      <button
        (click)="
          noCitationStyle.id !== currentCitationStyle.id &&
            onChangeCitationStyle(noCitationStyle)
        "
        [disabled]="noCitationStyle.id === currentCitationStyle.id"
        class="dropdown-item"
        [class.disabled]="noCitationStyle.id === currentCitationStyle.id"
        id="qa-select-citation-style-{{ getIdForStyle(noCitationStyle) }}"
        type="button"
        i18n="@@citationSwitcherMenu-btn-none"
      >
        None
      </button>
    </li>

    <li *ngIf="defaultCitationStyle ? true : false">
      <button
        (click)="
          defaultCitationStyle.id !== currentCitationStyle.id &&
            onChangeCitationStyle(defaultCitationStyle)
        "
        [disabled]="defaultCitationStyle.id === currentCitationStyle.id"
        class="dropdown-item"
        [class.disabled]="defaultCitationStyle.id === currentCitationStyle.id"
        id="qa-select-citation-style-{{ getIdForStyle(defaultCitationStyle) }}"
        type="button"
        i18n="@@citationSwitcherMenu-btn-default"
      >
        {{ defaultCitationStyle.description }} (default)
      </button>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li *ngFor="let style of nonDefaultCitationStyles">
      <button
        (click)="
          style.id !== currentCitationStyle.id && onChangeCitationStyle(style)
        "
        [disabled]="style.id === currentCitationStyle.id"
        class="dropdown-item"
        [class.disabled]="style.id === currentCitationStyle.id"
        id="qa-select-citation-style-{{ getIdForStyle(style) }}"
        type="button"
      >
        {{ style.description }}
      </button>
    </li>
  </ul>
</div>
